// Establishes the legacy globals that the flex-forms bundle's downstream modules
// (unic-sc-flex, jQuery UMD plugins, LLB-customized form/datepicker) read at load time.
// Must be the first import in flex.js — see _jquery-globals.js for the hoisting reasoning.
import $ from 'jquery';
import _ from 'lodash';

window.jQuery = $;
window.$ = $;
window._ = _;
window._.contains = _.includes;
window.Modernizr = {};
